import { render, staticRenderFns } from "./Wm5.vue?vue&type=template&id=66a8b5f7&scoped=true"
import script from "./Wm5.vue?vue&type=script&lang=js"
export * from "./Wm5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a8b5f7",
  null
  
)

export default component.exports